// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"_3gpGV","textFake":"_3RJjs","textTicker":"XKuaL","beginAnimation":"_2kmqG","ticker":"_13ryj","scrollingText":"_1uhBA"};